<script lang="ts">
	import Button from '$lib/components/atoms/button/Button.svelte';
	import Link from '$lib/components/atoms/link/Link.svelte';
	import { createSessionStorageNumberStore } from '$lib/utils/sessionStorage';
	import { onMount } from 'svelte';

	interface Props {
		description?: string;
		ctaLink?: string;
		ctaText?: string;
		delay?: number;
		maxNbOpenPerSession?: number;
		sessionKey?: string;
		bgImage?: string;
		closeBtnAriaLabel?: string;
	}

	const {
		description = '',
		ctaLink = '',
		ctaText = '',
		delay = 0,
		maxNbOpenPerSession = 0,
		sessionKey = '',
		bgImage = '',
		closeBtnAriaLabel = '',
	}: Props = $props();

	const sessionOpenCount = createSessionStorageNumberStore(sessionKey, 0);

	let showToast = $state(false);

	function open() {
		if (maxNbOpenPerSession && $sessionOpenCount >= maxNbOpenPerSession) {
			return;
		}

		showToast = true;
		sessionOpenCount.increment();
	}

	function close() {
		showToast = false;
	}

	onMount(() => {
		let timeoutId: number | undefined;
		if (delay) {
			timeoutId = window.setTimeout(() => {
				open();
			}, delay);
		} else {
			open();
		}

		return () => {
			clearTimeout(timeoutId);
		};
	});
</script>

{#if showToast}
	<div
		class="fixed bottom-0 z-ontop pointer-events-none w-full flex justify-center md:justify-end md:bottom-2 md:right-2 p-2"
	>
		<div
			class={['slide-up w-full min-h-[128px] md:max-w-90 pointer-events-auto bg-primary text-white p-4 rd-2 flex flex-col justify-between', { 'pl-12': bgImage }]}
			style="--toast-bg-image: url({bgImage})"
		>
			<div class="flex justify-between w-full">
				<div class="text-sm">{description}</div>
				<Button
					variant="ghost"
					size="md"
					icon="close"
					color="white"
					class="translate-x-[1rem] translate-y-[-0.75rem]"
					ariaLabel={closeBtnAriaLabel}
					onclick={close}
				/>
			</div>
			<Link
				href={ctaLink}
				target="_blank"
				rel="external"
				icon="east"
				class="w-full min-w-full mt-3"
				button="filled"
				color="white"
				onclick={close}
			>
				{ctaText}
			</Link>
		</div>
	</div>
{/if}

<style>
	@keyframes slideInBottomToTop {
		from {
			transform: translateY(100%);
		}
		to {
			transform: translateY(0);
		}
	}

	.slide-up {
		animation: slideInBottomToTop 0.7s ease forwards;
		background-image: var(--toast-bg-image);
		background-position: left center;
		background-repeat: no-repeat;
		background-size: 40px 96px;
	}
</style>
